import { createFileRoute } from "@tanstack/react-router";
import ProtectedRoute from "@/components/ProtectedRoute";
import AdminSEO from "@/pages/admin/AdminSEO";
import { adminHead } from "@/lib/route-seo";

export const Route = createFileRoute("/admin/seo")({
  head: () => adminHead("SEO Rankings | Admin", "SEO keyword tracking and rankings.", "/admin/seo"),
  component: () => (
    <ProtectedRoute>
      <AdminSEO />
    </ProtectedRoute>
  ),
});
